<template>
    <v-container class="fill-height" fluid style="background-color: gray">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="grey lighten-4">
                    <v-toolbar color="bal-red" dark flat>
                        <v-img contain max-height="50px" :src="require('../../assets/images/Balsnack-logo.png')" />
                    </v-toolbar>
                    <v-card-text v-if="step === 'successful'">
                        <v-list-item-title class="headline mb-1">Registration successful!</v-list-item-title>
                        <v-list-item-subtitle
                            >Everything went well. Check your mailbox for activation.</v-list-item-subtitle
                        >
                    </v-card-text>
                    <v-card-text v-else>
                        <v-list-item-title class="headline mb-1">Register</v-list-item-title>
                        <v-list-item-subtitle>Company information:</v-list-item-subtitle>
                        <v-form v-model="form_validation">
                            <v-text-field
                                color="bal-red"
                                label="Company name *"
                                name="company_name"
                                prepend-icon="people"
                                type="text"
                                :rules="[rules.required]"
                                v-model="registration.company_name"
                                @input="updateField($event, 'company_name')"
                            />
                            <v-text-field
                                color="bal-red"
                                label="Company registry code *"
                                name="company_registry_code"
                                prepend-icon="people"
                                type="text"
                                :rules="[rules.required]"
                                required
                                v-model="registration.company_regCode"
                                @input="updateField($event, 'company_regCode')"
                            />
                            <v-text-field
                                color="bal-red"
                                label="Company address"
                                name="address"
                                prepend-icon="home"
                                type="text"
                                v-model="registration.company_address"
                                @input="updateField($event, 'company_address')"
                            />
                            <v-select
                                color="bal-red"
                                label="Company country"
                                name="country"
                                prepend-icon="flag"
                                v-model="registration.company_country"
                                @input="updateField($event, 'company_country')"
                                :items="countries"
                            ></v-select>

                            <v-list-item-subtitle>Person information:</v-list-item-subtitle>

                            <v-text-field
                                color="bal-red"
                                label="Email *"
                                name="email"
                                prepend-icon="email"
                                type="text"
                                :rules="[
                                    v =>
                                        !v ||
                                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                                        'E-mail must be valid',
                                    rules.required
                                ]"
                                v-model="registration.user_email"
                                @input="updateField($event, 'user_email')"
                            />
                            <v-text-field
                                color="bal-red"
                                label="Firstname"
                                name="firstname"
                                prepend-icon="person"
                                type="text"
                                v-model="registration.user_firtstname"
                                @input="updateField($event, 'user_firtstname')"
                            />
                            <v-text-field
                                color="bal-red"
                                label="Lastname"
                                name="lastname"
                                prepend-icon="person"
                                type="text"
                                v-model="registration.user_lastname"
                                @input="updateField($event, 'user_lastname')"
                            />
                            <v-select
                                color="bal-red"
                                label="Locale"
                                name="locale"
                                prepend-icon="flag"
                                v-model="registration.user_locale"
                                @input="updateField($event, 'user_locale')"
                                :items="locales"
                            ></v-select>
                            <v-text-field
                                color="bal-red"
                                id="password"
                                label="Password *"
                                name="password"
                                prepend-icon="lock"
                                type="password"
                                :rules="[rules.password, rules.required]"
                                v-model="registration.user_password"
                                @input="updateField($event, 'user_password')"
                            />

                            <v-text-field
                                color="bal-red"
                                id="repeated_password"
                                label="Repeat password *"
                                name="repeated_password"
                                prepend-icon="lock"
                                type="password"
                                :rules="[rules.password, rules.required]"
                                v-model="registration.user_repeated_password"
                                @input="updateField($event, 'user_repeated_password')"
                            />
                        </v-form>
                        <v-alert v-if="registration.error" v-model="registration.error" type="error" color="bal-red">
                            {{ registration.error }}
                        </v-alert>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn v-if="step === 'successful'" color="bal-red" dark @click="handleBackClick">Back</v-btn>
                        <v-btn v-else color="bal-red" :disabled="!form_validation" dark @click="handleRegisterClick"
                            >Register</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Store from "../../store";
import { mapActions, mapState } from "vuex";
import router from "../../router";

export default {
    name: "registration",
    data() {
        return {
            locales: ["en", "et", "ru"],
            countries: ["ET", "EN", "RU"],
            step: null,
            form_validation: false,
            rules: {
                required: value => !!value || "Required.",
                password: value => {
                    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
                    return (
                        pattern.test(value) ||
                        "Min. 8 characters with at least one capital letter, a number and a special character."
                    );
                }
            }
        };
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState(["registration"])
    },
    methods: {
        ...mapActions(["registerUserAndCompany"]),
        updateField(value, field) {
            Store.commit("updateRegistrationProperty", { prop: field, value: value });
        },
        async handleRegisterClick() {
            let error = "";
            Store.commit("updateRegistrationProperty", { prop: "error", value: "" });
            if (
                this.registration.user_password !== this.registration.user_repeated_password ||
                this.registration.user_password.length < 8
            ) {
                error += "There was an error in the password. ";
                Store.commit("updateRegistrationProperty", { prop: "error", value: error });
            }
            if (!this.registration.error) {
                let result = await this.registerUserAndCompany(this.registration);
                if (result.success === 1) {
                    this.step = "successful";
                } else {
                    error += "Something went wrong. Maybe this email or company name already exists. ";
                    Store.commit("updateRegistrationProperty", { prop: "error", value: error });
                }
            }
        },
        handleBackClick() {
            router.push("/login");
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 13) {
                this.handleRegisterClick();
            }
        }
    }
};
</script>

<style scoped></style>
